import React from "react";
import PropTypes from "prop-types";
import Dropdown from "./Dropdown";
import ButtonGroup from "./ButtonGroup";
import SVGIcons from "assets/icon";
const propTypes = {
  svgicon: PropTypes.elementType,
  label: PropTypes.string,
  onClickDropdownButton: PropTypes.any
};

const defaultProps = {
  label: ""
};

const Button = React.forwardRef(
  //({ label, SVGIcon, children, onClickDropdownButton, ...props }, ref) => {
  ({ label, SVGIcon, children, onClickDropdownButton, id, ...props }, ref) => {
    let inputChildren = [];
    let otherChildren = [];

    children.forEach(value => {
      if (value === null || value === undefined) {
        return;
      }
      if (value.type && value.type === "input") {
        inputChildren.push(value);
      } else {
        otherChildren.push(value);
      }
    });
    return (
      <label {...props}>
        {inputChildren && inputChildren}
        <Dropdown as={ButtonGroup}>
          <Dropdown.Toggle
            id={id}
            variant="success"
            className="svg-dropdown-type-toggle svg-dropdown-type--button"
            // as="label"
          >
            <div className={"svgContainer"}>{SVGIcon && <SVGIcon />}</div>

            <span>
              {label + " "}
              <div className="svgContainer svg-dropdown-type--expand">
                <SVGIcons.SVGDownTriangleIcon />
              </div>
            </span>
          </Dropdown.Toggle>
          {otherChildren && otherChildren}
        </Dropdown>
      </label>
    );
  }
);

Button.displayName = "SVGDropdownTypeButton";
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
